import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';

import type { UiPreferencesResponse, UpdateUiPreferencesParameters } from './types';

const getUiPreferences = (teamId: string) => {
	return fetch<UiPreferencesResponse>(urls.uiPreference.schedule.team.teamId.url({ teamId }));
};

const updateUiPreferences = ({ teamId, key, value }: UpdateUiPreferencesParameters) => {
	return fetch(urls.uiPreference.schedule.team.teamId.url({ teamId }), {
		method: 'PATCH',
		body: { [key]: value },
	});
};

export const endpoints = {
	getUiPreferences,
	updateUiPreferences,
};
